<template>
  <div style=" background-color: #F8F9FB;padding: 0 60px;">
    <hhead></hhead>
    <div class="rz_body" :style="{ minHeight: MHeight }">
      <div class="left" :style="{ minHeight: MHeight }">
        <div>
          <img src="../../../../assets/images/crm/renzheng/xx.png" alt="" />
          <p>基本信息</p>
        </div>
        <div class="shu"></div>
        <div>
          <img src="../../../../assets/images/crm/renzheng/tz.png" alt="" />
          <p style="color: #475173;">投资策略/理念</p>
        </div>
      </div>
      <div class="right" :style="{ height: MHeight, overflow: 'scroll' }">
        <div class="form_box">
          <label for="">
            <p><span>*</span> 企业名称：</p>
            <el-input
              @blur="inpBlur"
              v-model="qy_name"
              placeholder=""
            ></el-input>
            <span @click="apply" v-show="show" style="cursor: pointer;"
              >企业已认证，申请加入管理>></span
            >
          </label>
          <p>
            需与营业执照上的企业名称完全一致，信息审核成功后，企业名称不可修改
          </p>

          <label for="">
            <p>工商营业执照：</p>
            <div class="center" style="color: #475173;">
              <el-upload
                class="avatar-uploader"
                :action="this.$store.state.api + '/ad/upload/upload_file'"
                :show-file-list="false"
                name="file"
                accept="image/png, image/jpeg"
                :on-success="handleAvatarSuccess"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i
                  v-else
                  style="color: #dcdfe6;width: 150px;height: 150px;line-height: 150px; border: 1px dashed #dcdfe6;"
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
              </el-upload>
              请上传最新的营业执照<br />
            </div>
          </label>

          <!--  上传照片 -->

          <p style="margin-top: -15px;">
            格式要求：原件照片，扫描件或者加盖公章的复印件，支持jpg,jpeg,bmg,png等格式照片，大小不超过5M
          </p>

          <label for="">
            <p>简称：</p>
            <el-input v-model="jc_name" placeholder=""></el-input>
          </label>

          <label for="">
            <p>社会信用代码：</p>
            <el-input v-model="qy_register" placeholder=""></el-input>
          </label>
          <p>请输入15位统一社会信用代码</p>

          <!-- <label for="">
            <p><span>*</span> 入驻申请函：</p>
            <div class="center" style="color: #475173;">
              请下载企业入驻申请函，签字盖章之后上传扫描件 <br />
            </div>
          </label> -->

          <!-- <p style="margin-top: -15px;">
            <a
              :href="this.$store.state.api + '//temp.docx'"
              style="color: #FF4239;"
              >企业入驻申请函</a
            >
          </p> -->

          <!--  上传照片 -->
          <!-- <el-upload
            class="avatar-uploader"
            :action="this.$store.state.api + '/ad/upload/upload_file'"
            :show-file-list="false"
            name="file"
            accept="image/png, image/jpeg"
            :on-success="handleAvatarSuccess_t"
          >
            <img v-if="imageUrl_t" :src="imageUrl_t" class="avatar" />
            <i
              v-else
              style="color: #dcdfe6;width: 150px;height: 150px;line-height: 150px; border: 1px dashed #dcdfe6;"
              class="el-icon-plus avatar-uploader-icon"
            ></i>
          </el-upload> -->

          <label for="">
            <p>成立时间：</p>
            <!-- <el-date-picker
            v-model="value1"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker> -->
            <div style="width: 400px;">
              <el-date-picker
                v-model="cl_time"
                type="date"
                value-format="yyyy/MM/dd"
                placeholder=""
              >
              </el-date-picker>
            </div>
            <!-- <el-input v-model="cl_time" placeholder=""></el-input> -->
          </label>
          <p>需与证件上的成立时间完全一致，信息审核成功后，成立时间不可修改</p>

          <label for="">
            <p>注册资本：</p>
            <el-input v-model="capital" placeholder=""></el-input>
          </label>
          <p>需与证件上的注册资本完全一致，信息审核成功后，注册资本不可修改</p>

          <label for="">
            <p>投资范围：</p>
            <textarea class="text_inp" v-model="Range"></textarea>
          </label>
          <div class="btn_x" @click="submit" style="margin-bottom: 20px;">
            下一步
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hhead from '../../header/index';
import './style.css';
export default {
  components: { hhead },
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 94 + 'px',
      qy_name: this.$store.state.jgName ? this.$store.state.jgName : '', // 企业名称
      jc_name: '', //简称
      qy_register: '', //营业执照注册号：
      cl_time: '', //成立时间
      capital: '', //注册资本
      Range: '', //投资范围
      imageUrl: '',
      imageUrl_t: '',
      imgPath: '',
      imgPath_t: '',
      show: false,
      entId: '',
      shortcuts: [
        {
          text: '今天',
          value: new Date(),
        },
        {
          text: '昨天',
          value: (() => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          })(),
        },
        {
          text: '一周前',
          value: (() => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            return date;
          })(),
        },
      ],
      value1: '',
      value2: '',
      value3: '',
      defaultTime: new Date(2000, 1, 1, 12, 0, 0), // '12:00:00'
    };
  },
  mounted() {
    if (this.$store.state.registerMsg) {
      let msg = this.$store.state.registerMsg;
      this.qy_name = msg.qy_name;
      this.jc_name = msg.jc_name;
      this.qy_register = msg.qy_register;
      this.cl_time = msg.cl_time;
      this.capital = msg.capital;
      this.Range = msg.Range;
      this.imageUrl = msg.imageUrl;
      this.imageUrl_t = msg.imageUrl_t;
      this.imgPath = msg.imgPath;
      this.imgPath_t = msg.imgPath_t;
    }

    if (this.$route.query.type) {
      this.$axios
        .post('/crm/ent/getAuthInfo', {
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          //   console.log(res);
          if (res.data.code == 403) {
            this.qy_name = res.data.data.name;
            this.jc_name = res.data.data.abbrName;
            this.qy_register = res.data.data.code;
            this.cl_time = res.data.data.createDate;
            this.capital = res.data.data.initMoney;
            this.Range = res.data.data.bizArea;
            this.imageUrl = this.$store.state.api + res.data.data.applyDoc;
            this.imageUrl_t = this.$store.state.api + res.data.data.codePic;
          }
        });
    }
  },
  methods: {
    inpBlur() {
      //   console.log(this.qy_name);
      if (this.qy_name) {
        this.$axios
          .post('/crm/ent/queryEnt', {
            key: this.qy_name,
            apiToken: this.$store.state.usermsg.apiToken,
          })
          .then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.entId = res.data.data.id;
              this.show = true;
            } else {
              this.show = false;
            }
          });
      } else {
        this.show = false;
      }
    },
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      let h = date.getHours();
      h = h < 10 ? '0' + h : h;
      let m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      let s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '年' + MM + '月' + d + '日';
    },
    submit() {
      //下一步
      //   &&
      //     this.qy_register &&
      //     this.cl_time &&
      //     this.capital &&
      //     this.Range &&
      //     this.jc_name
      if (this.qy_name) {
        let obj = {
          qy_name: this.qy_name,
          jc_name: this.jc_name,
          qy_register: this.qy_register,
          cl_time: this.cl_time,
          capital: this.capital,
          Range: this.Range,
          imageUrl: this.imageUrl,
          imageUrl_t: this.imageUrl_t,
          imgPath: this.imgPath,
          imgPath_t: this.imgPath_t,
        };
        this.$store.state.registerMsg = obj; //合作方注册信息存储到vuex
        // localStorage.setItem('msg', JSON.stringify(obj));
        if (!this.$route.query.type) {
          this.$router.push('/crm/authentication_s');
        } else {
          this.$router.push(
            `/crm/authentication_s?type=edit&id=${this.$route.query.id}`
          );
        }
      } else {
        this.$alert('请填写企业名称', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    apply() {
      //申请加入
      this.$axios
        .post('/crm/mem/joinEnt', {
          apiToken: this.$store.state.usermsg.apiToken,
          entId: this.entId,
        })
        .then((res) => {
          //   console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.$alert('加入成功', {
              confirmButtonText: '确定',
              type: 'success',
              center: true,
            })
              .then(() => {
                this.$router.push('/crm/qyQuery/state');
              })
              .catch(() => {});
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: '确定',
              type: 'error',
              center: true,
            })
              .then(() => {})
              .catch(() => {});
          }
        })
        .catch((err) => {
          //   console.log(err);
        });
    },

    handleAvatarSuccess(res, file) {
      //上传营业执照
      //   console.log(res);
      if (res.code == 200) {
        // this.$message.success(res.message);
        this.imageUrl = URL.createObjectURL(file.raw);
        this.imgPath = res.data.filePath;
        this.$axios
          .post('/crm/upload_Ent', {
            path: res.data.filePath,
            apiToken: this.$store.state.usermsg.apiToken,
          })
          .then((result) => {
            // console.log(result);
            let rep = result.data;
            this.tokenInvalid(result);
            if (rep.code == 200) {
              this.qy_name = rep.data.company;
              this.qy_register = rep.data.creditNo;
              this.cl_time = rep.data.createTime;
              this.capital = rep.data.scope || '';
              this.inpBlur();
            } else {
              this.$alert(rep.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$alert(res.message, {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    handleAvatarSuccess_t(res, file) {
      //   console.log(res);
      this.tokenInvalid(res);
      if (res.code == 200) {
        // this.$message.success(res.message);
        this.imageUrl_t = URL.createObjectURL(file.raw);
        this.imgPath_t = res.data.filePath;
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/authentication/authentication_t/index.vue